/* TH Klick-Zaehler: Telefon- und WhatsApp-Klicks an GTM (dataLayer). Kein externes Skript. */
(function () {
  if (window.__thKlickZaehler) return;
  window.__thKlickZaehler = true;
  window.dataLayer = window.dataLayer || [];
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    var href = (a.getAttribute('href') || '').trim().toLowerCase();
    var ev = null;
    if (href.indexOf('tel:') === 0) ev = 'telefon_klick';
    else if (href.indexOf('https://wa.me/') === 0 || href.indexOf('https://api.whatsapp.com/') === 0 || href.indexOf('whatsapp:') === 0) ev = 'whatsapp_klick';
    if (!ev) return;
    window.dataLayer.push({ event: ev, seite: location.pathname, link_text: (a.textContent || '').trim().slice(0, 60) });
  }, { capture: true, passive: true });
})();
